var map = {
	"./amex.png": "./src/assets/cards/images/amex.png",
	"./chip.png": "./src/assets/cards/images/chip.png",
	"./dinersclub.png": "./src/assets/cards/images/dinersclub.png",
	"./discover.png": "./src/assets/cards/images/discover.png",
	"./jcb.png": "./src/assets/cards/images/jcb.png",
	"./mastercard.png": "./src/assets/cards/images/mastercard.png",
	"./troy.png": "./src/assets/cards/images/troy.png",
	"./unionpay.png": "./src/assets/cards/images/unionpay.png",
	"./visa.png": "./src/assets/cards/images/visa.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/cards/images sync recursive ^\\.\\/.*\\.png$";